import * as React from 'react';

import type { XdpV1_Org_Coursera_Xdp_Sdp_SdpCourse as Course } from '__generated__/graphql-types-do-not-use';

import type { SubscriptionTiersProductPrice } from 'bundles/coursera-plus-landing-page/contentfulData/LandingPageDataProvider';
import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import type { Partner } from 'bundles/enroll-common/hooks/useGetPartnerNamesByIds';
import type { GroupsData, InvitedProgramsData, ProgramsData } from 'bundles/enroll-common/lib/apiClient';
import type { FormattedCourse } from 'bundles/enroll-common/types/enrollSectionTypes';
import type { FormattedGraphqlProductOwnership } from 'bundles/entitlements-common/utils/entitlementProductOwnershipUtils';
import type CourseTypeMetadataV1 from 'bundles/naptimejs/resources/courseTypeMetadata.v1';
import type OnDemandSpecializationsV1 from 'bundles/naptimejs/resources/onDemandSpecializations.v1';
import type PromotionDetailsV1 from 'bundles/naptimejs/resources/promotionDetails.v1';
import type PromotionEligibilitiesV1 from 'bundles/naptimejs/resources/promotionEligibilities.v1';
import type S12nDerivativesV1 from 'bundles/naptimejs/resources/s12nDerivatives.v1';
import type { OwnableProductByUnderlyingProductItemId } from 'bundles/ownable-products-common/hooks/useFindOwnableProducts';
import type { ProductPrices } from 'bundles/ownable-products-common/hooks/useGetProductPrices';

type BaseDataContextType = {
  isCourseraPlusEligibleProduct?: boolean;
  isSpecialization: boolean;
  course: FormattedCourse;
  courses?: Course[];
  courseraPlusMonthlyProductPrice?: SubscriptionTiersProductPrice;
  courseraPlusAnnualProductPrice?: SubscriptionTiersProductPrice;
  enrollmentAvailableChoices: EnrollmentChoices;
  isGuestCheckout?: boolean;
  productPrice?: ProductPrices;
  promotionDetails?: PromotionDetailsV1 | null;
  promotionEligibilities?: PromotionEligibilitiesV1 | null;
  s12nDerivatives?: S12nDerivativesV1;
  s12nPrepaidProductPrices?: ProductPrices[];
  courseraPlusPrepaidProductPrices?: ProductPrices[];
  s12nPrepaidProductPrice?: ProductPrices;
  s12nProductPrice?: ProductPrices;
  courseraPlusMonthlyUpsellProductPrice?: ProductPrices;
  partners?: Partner[];
  s12nSubscriptionOwnableProduct?: OwnableProductByUnderlyingProductItemId;
} & GroupsData &
  InvitedProgramsData &
  ProgramsData;

export type CourseEnrollModalDataContextType = BaseDataContextType & {
  courseTypeMetadataWithVersion: CourseTypeMetadataV1;
  ownsCourseraLite?: boolean;
  s12n?: OnDemandSpecializationsV1;
  s12ns?: OnDemandSpecializationsV1[];
  s12nCourses?: FormattedCourse[];
};

export type S12nEnrollModalDataContextType = BaseDataContextType & {
  productOwnerships: FormattedGraphqlProductOwnership;
  s12n: OnDemandSpecializationsV1;
};

const PageDataContext = React.createContext<
  CourseEnrollModalDataContextType | S12nEnrollModalDataContextType | undefined
>(undefined);

export default PageDataContext;
